module.exports = __webpack_public_path__ + "static/media/TalkedToOne.9a65c3e4.png";